import { DocumentExport16 } from '@carbon/icons-react/lib/';
import { Button, FormGroup, Loading, TextArea, TextInput } from 'carbon-components-react';
import React, { Component } from 'react';
import { Section } from '../../../lib/react-scroll-section/src/index';
import '../../../scss/custom.scss';
import FileDownLoadButton from '../../common/FileDownloadButton';
import { Offline, Online } from '../../common/OnLineOffLine';
import { getSuccess, getError, entitiesLabels, apioperation } from '../../../helpers/Constants';
import EmailChips from '../../../helpers/EmailChips';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import SimpleReactValidator from 'simple-react-validator';
import Save16 from '@carbon/icons-react/lib/save/16';
import Email16 from '@carbon/icons-react/lib/email/16';
import { api, dynamic } from '../../../helpers/api/api';

const validations = {}

class InspectionDistribution extends Component {

      constructor(props) {
            super(props);
            this.validator = new SimpleReactValidator();

            this.state = {
                mailTo: this.props.inspectionModel.mailTo,
                mailCc: this.props.inspectionModel.mailCC,
                mailSubject: this.props.inspectionModel.mailSubject,
                mailBody: this.props.inspectionModel.mailBody,
                  isDisabled: false,
                  isLoadingReportFile: false,
                  id: this.props.inspectionModel.id
            };
      }

    componentDidMount() {
        this.setState({
            mailTo: this.props.inspectionModel.mailTo,
            mailCc: this.props.inspectionModel.mailCC,
            mailSubject: this.props.inspectionModel.mailSubject,
            mailBody: this.props.inspectionModel.mailBody,
            isDisabled: false,
            isLoadingReportFile: false,
            id: this.props.inspectionModel.id
        });
        this.setMailSubject();
    }

    setMailSubject() {
        if (!this.state.mailSubject) {
            const subject = `Inspection ID ${this.props.inspectionModel.inspectionCode}  Report`;
            this.setState({mailSubject: subject});
        } 
    }

      updateState = (property, value) => {
            let copy = {...this.state[property]};
            copy = value
            this.setState({[property]: copy})
      }

      save = () => {
          this.setState({ isLoadingReportFile: true });
          if (this.validator.allValid()) {
              
              let datiForm = this.state;

              api
                  .put('/inspection/report', datiForm)
                  .then((response) => {
                      if (response.status === 200) {
                          showNotification.success(`${entitiesLabels.SUCCESS}`,
                              this.props.inspectionModel.inspectionCode != null
                                  ? `${entitiesLabels.INSPECTION} ${entitiesLabels.WITHCODE} ${this.props.inspectionModel.inspectionCode} ${getSuccess('report distribution', apioperation.PUT)}`
                                  : getSuccess(entitiesLabels.INSPECTION, apioperation.POST)
                          );
                      } else {
                          showNotification.error();
                      }
                  })
                  .catch((error) => {
                      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.POST));
                  })
                  .finally(() => {
                      this.setState({ isLoadingReportFile: false });
                  });
                  //this.props.updateCacheIncidentModel(datiForm, 'tabReport');
                  //Salvare tutto (forse da prendere tramite props e passargli i dati qui insieriti)
            } else {
                  this.setState({ isLoadingReportFile: false });
                  showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.INSPECTION + ' required fields are missing');
                  this.validator.showMessages();
                  this.forceUpdate();
            }
    }

    send = () => {
        this.setState({ isLoadingReportFile: true });
        if (this.validator.allValid()) {
            this.sendDistribution();
        } else {
            this.setState({ isLoadingReportFile: false });
            showNotification.warning(
                `${entitiesLabels.WARNING}`,
                `${entitiesLabels.NOTIFICATION} required fields are missing  `
            );
            this.validator.showMessages();
        }
    };


    sendDistribution = () => {
        api
            .put('/inspection/distribution/send', this.state)
            .then((response) => {
                if (response.status === 200) {
                    showNotification.success(`${entitiesLabels.SUCCESS}`, 'Successfully sent');
                } else {
                    showNotification.error(`${entitiesLabels.ERROR}`,
                        getError('Unsuccessfully sent', entitiesLabels.INSPECTION, apioperation.POST)
                    );
                }
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.POST));
            })
            .finally(() => {
                this.setState({ isLoadingReportFile: false });
            });
    };

    getInspectionReportCode(id) {
        return "Inspection_Report_" + this.props.inspectionModel.inspectionCode+".pdf"
    }

      render() {
            // this.validator.purgeFields();
            const validations = {
                  mailBody: this.validator.message('mailBody', this.state.mailBody, 'required'),
                  mailSubject: this.validator.message('mailSubject', this.state.mailSubject, 'required'),
                  mailTo: this.validator.message('mailTo', this.state.mailTo && this.state.mailTo[0] , 'required'),
                  //mailCc: this.validator.message('mailCc', this.state.mailCc && this.state.mailCc[0], 'required'),
            };
            
            return (
                  <>
                        {/* <ConfirmAlertCustom {...confirmDelProps()} /> */}
                        <Loading active={this.state.isLoadingReportFile} withOverlay />
                        <div className="bx--col-lg-12 bx--col-md-12">
                              <div className="bx--row section--title">
                                    <h3 className="title--medium--expressive selection-items-list-costum">
                                          Report Distribution
                                    </h3>
                                    <Online>
                                          <FileDownLoadButton
                                                onError={(error) => {showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION_REPORT, apioperation.DOWNLOAD))}}
                                                size="small"
                                                className=" selection-items-list-costum bx--data-table-container-absolute  "
                                                renderIcon={DocumentExport16}
                                                iconDescription="Download Report"
                                                title="Download Report"
                                                kind="ghost"
                                                apiUrl={`/inspection/${this.props.inspectionModel.id}/exportreport`}
                                                //fileName={`Inspection_Report_${row.inspectionCode}.pdf`}
                                               fileName={this.getInspectionReportCode(this.props.inspectionModel.id)}

                                                onDownLoadStart={() => {
                                                this.setState({isLoadingReportFile: true})}}
                                                onDownLoadEnd={() => {
                                                      this.setState({isLoadingReportFile: false,});
                                                }}
                                          />
                                    </Online>
                              </div>

                              <div className="bx--row section--title">
                                    <div className="bx--col-lg-6 bx--col-md-4">
                                          <FormGroup legendText="Mail To* (Personal Email Addresses are not allowed​​)">
                                                <EmailChips
                                                      value={this.state.mailTo || ''}
                                                      type="text"
                                                      onChange={(value) => this.updateState('mailTo', value)}
                                                      disabled={this.state.isDisabled}
                                                      title= "&#9888; Do Not use Personal Accounts"
                                                      invalid={validations.mailTo != null}
                                                />
                                                {validations.mailTo}
                                          </FormGroup>
                                    </div>

                                    <div className="bx--col-lg-6 bx--col-md-4">
                                          <FormGroup legendText="Mail CC (Personal Email Addresses are not allowed​)">
                                                <EmailChips
                                                      value={this.state.mailCc || ''}
                                                      type="text"
                                                      onChange={(value) => this.updateState('mailCc', value)}
                                                      disabled={this.state.isDisabled}
                                                      title="&#9888; Do Not use Personal Accounts"
                                                      //invalid={validations.mailCc != null}
                                                />
                                                {/*{validations.mailCc}*/}
                                          </FormGroup>
                                    </div>
                              </div>

                              <div className="bx--row row-content">
                                    <div className="bx--col-lg-12 subject-row">
                                          <FormGroup legendText="Mail Subject* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                                <TextInput
                                                      id="mailSubject"
                                                      name="mailSubject"
                                                      alt="inspectionModel"
                                                      placeholder="Input subject"
                                                      value={this.state.mailSubject || ''}
                                                      onChange={(el) =>this.updateState('mailSubject', el.target.value)}
                                                      type="text"
                                                      hideLabel={true}
                                                      labelText=""
                                                      disabled={this.state.isDisabled}
                                                      invalid={validations.mailSubject != null}
                                                />
                                               {validations.mailSubject}
                                          </FormGroup>
                                    </div>
                              </div>

                              <div className="bx--row row-content">
                                    <div className="bx--col-lg-12">
                                          <FormGroup legendText="Message* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                                <TextArea
                                                      maxLength={5000}
                                                      id="mailBody"
                                                      placeholder="Input message"
                                                      value={this.state.mailBody || ''}
                                                      onChange={(el) => this.updateState('mailBody', el.target.value)}
                                                      hideLabel={true}
                                                      labelText=""
                                                      light
                                                      rows={4}
                                                      cols={100}
                                                      disabled={this.state.isDisabled}
                                                      invalid={validations.mailBody != null}
                                                />
                                               {validations.mailBody}
                                          </FormGroup>
                                    </div>
                              </div>

                              <div className="bx--row">
                                    <div className="bx--row table-toolbar-custon-content-info-end">
                                        <Button
                                            size="default"
                                            renderIcon={Save16}
                                            kind="secondary"
                                            onClick={this.save}
                                            iconDescription=""
                                        >
                                            Save
                                        </Button>
                                    </div>
                              </div>

                        </div>      
                </>
            );
      }
}

export default InspectionDistribution;
